<div class="d-flex">
  <div class="profile-picture-panel">
    <app-profile-picture />
  </div>
  <div class="profile-data pl-3 font-size-primary">
    <div class="d-flex row">
      <div class="col-md-3">{{ "public.profile.name" | translate }}</div>
      <div class="col-md-9">{{ name }}</div>
    </div>
    <div class="d-flex row">
      <div class="col-md-3">{{ "public.profile.phone" | translate}}</div>
      <div class="col-md-9">{{ phone }}</div>
    </div>
    <div class="d-flex row">
      <div class="col-md-3">{{ "public.profile.email" | translate}}</div>
      <div class="col-md-9">{{ email }}</div>
    </div>
  </div>
  <div>
    <app-button startIcon="fa-pencil" (click)="onEditProfile()">
      {{ "public.profile.edit" | translate }}
    </app-button>
  </div>
</div>
